// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"42":"e632229a","453":"5c16539a","532":"1be3ac55","593":"a7585de8","772":"fe896f2a","786":"c3f10a26","855":"f1e5facd","868":"82b67666","895":"c7bebd3f","914":"a1c5bbe0"}[chunkId] + ".chunk.js";
};